import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'


let router=[];

router=router.concat(require('@/router/user'))
router=router.concat(require('@/router/role'))
router=router.concat(require('@/router/article'))
router=router.concat(require('@/router/photo'))
router=router.concat(require('@/router/question'))
router=router.concat(require('@/router/consultate'))
router=router.concat(require('@/router/birds'))
router=router.concat(require('@/router/common'))
router=router.concat(require("@/router/symptom"))
router.forEach(item=>{
  if(item.component===true){
    item.component=Layout
  }
})


export const constantRouterMap = router
export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap,
  mode:'history'
})




// WEBPACK FOOTER //
// ./src/router/index.js